import { useEffect, useRef } from "react";

const CLIENT_ID = process.env.REACT_APP_ADSENSE_CLIENT_ID;
const SLOT_ID = process.env.REACT_APP_ADSENSE_SLOT_ID;
const MULTIPLEX_SLOT_ID = process.env.REACT_APP_ADSENSE_MULTIPLEX_SLOT_ID;

export const AdSlot = ({ id, className = "", variant = "auto" }) => {
  const pushed = useRef(false);
  const isMultiplex = variant === "multiplex";
  const slot = isMultiplex ? MULTIPLEX_SLOT_ID : SLOT_ID;

  useEffect(() => {
    if (!CLIENT_ID || !slot || pushed.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch (e) {
      // adsense not loaded yet (e.g. not approved / blocked) — placeholder stays
    }
  }, [slot]);

  if (!CLIENT_ID || !slot) {
    return (
      <div
        data-testid={`ad-slot-${id}`}
        className={`rounded-[14px] border border-dashed border-[var(--border-c)] flex items-center justify-center p-4 min-h-[100px] text-[var(--muted)] text-xs uppercase tracking-[0.2em] ${className}`}
      >
        Advertisement
      </div>
    );
  }

  return (
    <div data-testid={`ad-slot-${id}`} className={`min-h-[100px] ${className}`}>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={CLIENT_ID}
        data-ad-slot={slot}
        {...(isMultiplex
          ? { "data-ad-format": "autorelaxed" }
          : { "data-ad-format": "auto", "data-full-width-responsive": "true" })}
      />
    </div>
  );
};
